// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteModal_wrapper__LvpHm","message":"DeleteModal_message__fX68K","targetElement":"DeleteModal_targetElement__kEeW1"};